import { render, staticRenderFns } from "./AddDetailsType.vue?vue&type=template&id=11e61034"
import script from "./AddDetailsType.vue?vue&type=script&lang=js"
export * from "./AddDetailsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports